import {useState, useEffect} from 'react'
import {v4 as uuidv4} from 'uuid'
import {format} from 'date-fns'
import AppointmentItem from '../AppointmentItem'
import './index.css'

const Appointments = () => {
  const storedList = JSON.parse(localStorage.getItem('List'))

  const [title, setTitle] = useState('')
  const [date, setDate] = useState('')
  const [appointmentList, setAppointmentList] = useState(
    storedList !== null ? storedList : [],
  )

  const [filterActive, setFilterActive] = useState(false)

  useEffect(() => {
    localStorage.setItem('List', JSON.stringify(appointmentList))
  })

  const onChangeTitle = event => {
    setTitle(event.target.value)
  }

  const onChangeDate = event => {
    setDate(event.target.value)
  }

  const onSubmitForm = event => {
    event.preventDefault()
    const formattedDate = format(new Date(date), 'dd MMMM yyyy, EEEE')
    const newAppointment = {
      id: uuidv4(),
      title,
      date: formattedDate,
      isStarred: false,
    }
    setAppointmentList(prevAppointment => [...prevAppointment, newAppointment])
    setTitle('')
    setDate('')
  }

  const onClickFilterStars = () => {
    setFilterActive(!filterActive)
  }

  const isStarredClick = id => {
    setAppointmentList(prevList =>
      prevList.map(eachList => {
        if (eachList.id === id) {
          return {...eachList, isStarred: !eachList.isStarred}
        }
        return eachList
      }),
    )
  }

  const getFilterAppointmentList = () => {
    if (filterActive) {
      return appointmentList.filter(eachList => eachList.isStarred === true)
    }
    return appointmentList
  }

  const filterAppointmentList = getFilterAppointmentList()
  const className = filterActive ? 'app-button-1' : 'app-button'
  const todayDate = format(new Date(), 'yyyy-MM-dd')

  return (
    <div className="bg-container">
      <div className="card-container">
        <div className="align-container">
          <form onSubmit={onSubmitForm}>
            <h1 className="heading">Add Appointment</h1>
            <label htmlFor="title" className="label">
              TITLE
            </label>
            <br />

            <input
              type="text"
              required
              id="title"
              placeholder="Title"
              className="input-title"
              value={title}
              onChange={onChangeTitle}
            />
            <br />
            <label htmlFor="date" className="label">
              DATE
            </label>
            <br />
            <input
              type="date"
              required
              id="date"
              min={todayDate}
              className="input-date"
              onChange={onChangeDate}
              value={date}
            />
            <br />
            <button type="submit" className="add-button">
              Add
            </button>
          </form>
          <div className="appointment-container">
            <img
              src="https://assets.ccbp.in/frontend/react-js/appointments-app/appointments-img.png"
              alt="appointments"
              className="appointment-img"
            />
          </div>
        </div>
        <hr className="hr-line" />
        <div className="appointments-star">
          <h1>Appointments</h1>
          <button
            type="button"
            className="button-star"
            onClick={onClickFilterStars}
          >
            <p className={className}>Starred</p>
          </button>
        </div>
        <ul className="list-main-container">
          {filterAppointmentList.map(eachAppointment => (
            <AppointmentItem
              eachAppointment={eachAppointment}
              key={eachAppointment.id}
              isStarredClick={isStarredClick}
            />
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Appointments
